<template>
  <div class="custom_text_input">
    <label :for="id" class="custom_input_label" v-if="label">
      {{ label }}
    </label>
    <validation-provider
      tag="div"
      :mode="mode"
      :name="label || name"
      v-slot="{ errors }"
      :rules="rules"
    >
      <v-text-field
        ref="input"
        :error-messages="errors[0]"
        v-bind="$attrs"
        @blur="blurHandler"
        solo
        :value="value"
        @input="(val) => $emit('input', val)"
        @keypress="onKeyPress"
        :id="id"
        :type="cusType"
        dense
        v-on="$listeners"
      >
        <template #prepend-inner>
          <slot name="prepend-inner"></slot>
        </template>
        <template #append>
          <slot name="append">
            <v-btn
              tabindex="-1"
              :class="{ 'with-line': cusType === 'password' }"
              icon
              v-if="type === 'password'"
              @click="changeType"
            >
              <vue-icon icon="eyeIcon"></vue-icon>
            </v-btn>
          </slot>
        </template>
      </v-text-field>
    </validation-provider>
  </div>
</template>

<script>
import { generateText } from "@/utils/pureFunctions";
import { numberOnly, alphaOnly } from "@/utils/inputRegExps";

export default {
  name: "CustomInputText",
  props: {
    mode: {
      type: String,
      validator(val) {
        const validateMode = ["passive", "lazy", "aggressive"];
        return validateMode.includes(val);
      },
    },
    name: {
      type: String,
      default: "Field",
    },
    value: {
      type: [String, Number],
    },
    label: {
      type: String,
    },
    rules: {},
    only: {
      type: String,
    },
    type: {
      type: String,
      default: "text",
    },
  },
  data() {
    return {
      id: null,
      cusType: this.type,
    };
  },
  methods: {
    focus() {
      this.$refs.input.focus();
    },
    blurHandler() {
      if (this.type === "password" && this.cusType !== "password") {
        this.cusType = "password";
      }
    },
    changeType() {
      this.cusType === "password"
        ? (this.cusType = "text")
        : (this.cusType = "password");
    },
    onKeyPress(e) {
      switch (this.only) {
        case "number":
          return numberOnly(e);
        case "alpha":
          return alphaOnly(e);
        default:
          return true;
      }
    },
  },
  created() {
    this.id = generateText(10);
  },
};
</script>

<style>
::-webkit-input-placeholder {
  /* Edge */
  color: #01456a !important;
  opacity: 0.5;
}

:-ms-input-placeholder {
  /* Internet Explorer */
  color: #01456a !important;
  opacity: 0.5;
}

::placeholder {
  color: #01456a !important;
  opacity: 0.5;
}

.custom_text_input {
  min-width: 100px;
}
</style>
